import { render, staticRenderFns } from "./MonthlyPriceInfo.vue?vue&type=template&id=0438a052"
import script from "./MonthlyPriceInfo.vue?vue&type=script&lang=js"
export * from "./MonthlyPriceInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports